import type { AppData } from "@lightningjs/sdk";

export const appData: AppData = {};

export default appData;
